#import "./ContractFields.graphql"

mutation DeleteContractDocument($id: ID!) {
  deleteContractDocument(input: { id: $id }) {
    contract {
      ...ContractFields
    }
  }
}
